import { render } from "./OrderPickup.vue?vue&type=template&id=9f4a6420"
import script from "./OrderPickup.vue?vue&type=script&lang=js"
export * from "./OrderPickup.vue?vue&type=script&lang=js"

import "./OrderPickup.vue?vue&type=style&index=0&id=9f4a6420&lang=css"

import exportComponent from "/codebuild/output/src396721354/src/serverlesspressoV3/frontends/vue-display-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__